import React from 'react'
import { observer } from 'mobx-react'

const SimpleTable = ({ renderers, labels, data }) => {
  function _renderRow (row, rowIdx) {
    return renderers.map((i, idx) => {
      return (
        <td key={idx}>{i(row, rowIdx)}</td>
      )
    })
  }

  return (
    <table className='table table-striped table-hover table-condensed'>
      {
        labels ? (
          <thead>
            <tr>{labels.map((i, idx) => (<th key={idx}>{i}</th>))}</tr>
          </thead>
        ) : null
      }
      <tbody>
        {data.map((i, idx) => (<tr key={idx}>{_renderRow(i, idx)}</tr>))}
      </tbody>
    </table>
  )
}

export default observer(SimpleTable)
